/**NIRSALSDGContribution — /corporate/nirsal/sdg */
import React, { useEffect, useState } from "react";
import { useNIRSAL } from "@/context/NIRSALContext";
import { PageHeader, SectionCard } from "@/components/ds";
import client from "@/api/client";

const SDG_COLORS = { 2:"#DDA63A",6:"#26BDE2",7:"#FCC30B",8:"#A21942",12:"#BF8B2E",13:"#3F7E44",15:"#56C02B" };

export default function NIRSALSDGContribution() {
  const { selectedPeriod, loading: ctxLoading } = useNIRSAL();
  const [sdgData, setSdgData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!selectedPeriod) return;
    setLoading(true);
    client.get(`/nirsal/sdg/${selectedPeriod}`).then(r => {
      setSdgData(r.data.sdg_contributions || []);
    }).finally(() => setLoading(false));
  }, [selectedPeriod]);

  if (ctxLoading || loading) return <div className="p-8 text-slate-400 text-sm">Loading SDG data…</div>;

  return (
    <div className="p-6 lg:p-8 bg-[#F8FAFC] min-h-screen space-y-6">
      <PageHeader label="SDG CONTRIBUTION" title="" />
      <p className="text-xs text-slate-400 -mt-4">Derived from live portfolio data · 7 SDGs addressed · OECD Rio Marker 2 climate finance alignment</p>
      <div className="grid grid-cols-2 gap-4">
        {sdgData.map(sdg => {
          const color = SDG_COLORS[sdg.id] || "#64748b";
          return (
            <div key={sdg.id} className="bg-white rounded-xl border border-slate-100 shadow-sm p-5" data-testid={`sdg-${sdg.id}`}>
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-xl flex items-center justify-center text-white text-sm font-black" style={{ background: color }}>{sdg.id}</div>
                <div>
                  <p className="text-sm font-bold text-slate-800">SDG {sdg.id} — {sdg.name}</p>
                  <span className={`text-[10px] font-bold px-2 py-0.5 rounded-full ${sdg.relevance === "High" ? "bg-emerald-100 text-emerald-700" : sdg.relevance === "Medium" ? "bg-amber-100 text-amber-700" : "bg-slate-100 text-slate-500"}`}>{sdg.relevance} Relevance · {sdg.type || "Direct"}</span>
                </div>
              </div>
              {sdg.quantified_value != null ? (
                <div className="bg-slate-50 rounded-lg p-3 mb-2">
                  <p className="text-xl font-black text-slate-900">{Number(sdg.quantified_value).toLocaleString()}</p>
                  <p className="text-xs text-slate-500">{sdg.impact_label}</p>
                </div>
              ) : (
                <div className="bg-slate-50 rounded-lg p-3 mb-2"><p className="text-xs text-slate-500 italic">Qualitative — quantification in Phase 2</p></div>
              )}
              <p className="text-xs text-slate-500">{sdg.driver}</p>
            </div>
          );
        })}
      </div>
      <div className="bg-blue-50 border border-blue-100 rounded-xl p-4 text-xs text-blue-700">
        <strong>OECD Rio Marker 2:</strong> The NIRSAL Green Credit Program is classified as Climate Finance (Adaptation + Mitigation) under OECD Rio Marker 2 criteria. All funded activities have climate change mitigation or adaptation as a principal objective.
      </div>
    </div>
  );
}
